"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryBlacklistAllResponse = exports.QueryBlacklistAllRequest = exports.QueryBlacklistResponse = exports.QueryBlacklistRequest = exports.QueryInternalTransfersResponse = exports.QueryInternalTransfersRequest = exports.Coin = exports.InternalTransfer = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const pagination_1 = require("../../../cosmos/base/query/v1beta1/pagination");
const timestamp_1 = require("../../../google/protobuf/timestamp");
exports.protobufPackage = "Switcheo.carbon.bank";
const baseInternalTransfer = {
    sender: "",
    receiver: "",
    transactionHash: "",
    transactionMemo: "",
    transactionBlockHeight: long_1.default.UZERO,
    senderUsername: "",
    receiverUsername: "",
    transactionCode: 0,
};
exports.InternalTransfer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.receiver !== "") {
            writer.uint32(18).string(message.receiver);
        }
        if (message.transactionHash !== "") {
            writer.uint32(26).string(message.transactionHash);
        }
        for (const v of message.coins) {
            exports.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.transactionMemo !== "") {
            writer.uint32(42).string(message.transactionMemo);
        }
        if (!message.transactionBlockHeight.isZero()) {
            writer.uint32(48).uint64(message.transactionBlockHeight);
        }
        if (message.transactionBlockTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.transactionBlockTime), writer.uint32(58).fork()).ldelim();
        }
        if (message.senderUsername !== "") {
            writer.uint32(66).string(message.senderUsername);
        }
        if (message.receiverUsername !== "") {
            writer.uint32(74).string(message.receiverUsername);
        }
        if (message.transactionCode !== 0) {
            writer.uint32(80).uint32(message.transactionCode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseInternalTransfer);
        message.coins = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.receiver = reader.string();
                    break;
                case 3:
                    message.transactionHash = reader.string();
                    break;
                case 4:
                    message.coins.push(exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.transactionMemo = reader.string();
                    break;
                case 6:
                    message.transactionBlockHeight = reader.uint64();
                    break;
                case 7:
                    message.transactionBlockTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.senderUsername = reader.string();
                    break;
                case 9:
                    message.receiverUsername = reader.string();
                    break;
                case 10:
                    message.transactionCode = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseInternalTransfer);
        message.sender =
            object.sender !== undefined && object.sender !== null
                ? String(object.sender)
                : "";
        message.receiver =
            object.receiver !== undefined && object.receiver !== null
                ? String(object.receiver)
                : "";
        message.transactionHash =
            object.transactionHash !== undefined && object.transactionHash !== null
                ? String(object.transactionHash)
                : "";
        message.coins = ((_a = object.coins) !== null && _a !== void 0 ? _a : []).map((e) => exports.Coin.fromJSON(e));
        message.transactionMemo =
            object.transactionMemo !== undefined && object.transactionMemo !== null
                ? String(object.transactionMemo)
                : "";
        message.transactionBlockHeight =
            object.transactionBlockHeight !== undefined &&
                object.transactionBlockHeight !== null
                ? long_1.default.fromString(object.transactionBlockHeight)
                : long_1.default.UZERO;
        message.transactionBlockTime =
            object.transactionBlockTime !== undefined &&
                object.transactionBlockTime !== null
                ? fromJsonTimestamp(object.transactionBlockTime)
                : undefined;
        message.senderUsername =
            object.senderUsername !== undefined && object.senderUsername !== null
                ? String(object.senderUsername)
                : "";
        message.receiverUsername =
            object.receiverUsername !== undefined && object.receiverUsername !== null
                ? String(object.receiverUsername)
                : "";
        message.transactionCode =
            object.transactionCode !== undefined && object.transactionCode !== null
                ? Number(object.transactionCode)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.transactionHash !== undefined &&
            (obj.transactionHash = message.transactionHash);
        if (message.coins) {
            obj.coins = message.coins.map((e) => (e ? exports.Coin.toJSON(e) : undefined));
        }
        else {
            obj.coins = [];
        }
        message.transactionMemo !== undefined &&
            (obj.transactionMemo = message.transactionMemo);
        message.transactionBlockHeight !== undefined &&
            (obj.transactionBlockHeight = (message.transactionBlockHeight || long_1.default.UZERO).toString());
        message.transactionBlockTime !== undefined &&
            (obj.transactionBlockTime = message.transactionBlockTime.toISOString());
        message.senderUsername !== undefined &&
            (obj.senderUsername = message.senderUsername);
        message.receiverUsername !== undefined &&
            (obj.receiverUsername = message.receiverUsername);
        message.transactionCode !== undefined &&
            (obj.transactionCode = message.transactionCode);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const message = Object.assign({}, baseInternalTransfer);
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.receiver = (_b = object.receiver) !== null && _b !== void 0 ? _b : "";
        message.transactionHash = (_c = object.transactionHash) !== null && _c !== void 0 ? _c : "";
        message.coins = ((_d = object.coins) !== null && _d !== void 0 ? _d : []).map((e) => exports.Coin.fromPartial(e));
        message.transactionMemo = (_e = object.transactionMemo) !== null && _e !== void 0 ? _e : "";
        message.transactionBlockHeight =
            object.transactionBlockHeight !== undefined &&
                object.transactionBlockHeight !== null
                ? long_1.default.fromValue(object.transactionBlockHeight)
                : long_1.default.UZERO;
        message.transactionBlockTime = (_f = object.transactionBlockTime) !== null && _f !== void 0 ? _f : undefined;
        message.senderUsername = (_g = object.senderUsername) !== null && _g !== void 0 ? _g : "";
        message.receiverUsername = (_h = object.receiverUsername) !== null && _h !== void 0 ? _h : "";
        message.transactionCode = (_j = object.transactionCode) !== null && _j !== void 0 ? _j : 0;
        return message;
    },
};
const baseCoin = { denom: "", amount: "" };
exports.Coin = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(18).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCoin);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCoin);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseCoin);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryInternalTransfersRequest = {
    address: "",
    sender: "",
    receiver: "",
    denom: "",
};
exports.QueryInternalTransfersRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.sender !== "") {
            writer.uint32(18).string(message.sender);
        }
        if (message.receiver !== "") {
            writer.uint32(26).string(message.receiver);
        }
        if (message.denom !== "") {
            writer.uint32(34).string(message.denom);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryInternalTransfersRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.receiver = reader.string();
                    break;
                case 4:
                    message.denom = reader.string();
                    break;
                case 5:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryInternalTransfersRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.sender =
            object.sender !== undefined && object.sender !== null
                ? String(object.sender)
                : "";
        message.receiver =
            object.receiver !== undefined && object.receiver !== null
                ? String(object.receiver)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.denom !== undefined && (obj.denom = message.denom);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseQueryInternalTransfersRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.sender = (_b = object.sender) !== null && _b !== void 0 ? _b : "";
        message.receiver = (_c = object.receiver) !== null && _c !== void 0 ? _c : "";
        message.denom = (_d = object.denom) !== null && _d !== void 0 ? _d : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryInternalTransfersResponse = {};
exports.QueryInternalTransfersResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.internalTransfers) {
            exports.InternalTransfer.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryInternalTransfersResponse);
        message.internalTransfers = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.internalTransfers.push(exports.InternalTransfer.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryInternalTransfersResponse);
        message.internalTransfers = ((_a = object.internalTransfers) !== null && _a !== void 0 ? _a : []).map((e) => exports.InternalTransfer.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.internalTransfers) {
            obj.internalTransfers = message.internalTransfers.map((e) => e ? exports.InternalTransfer.toJSON(e) : undefined);
        }
        else {
            obj.internalTransfers = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryInternalTransfersResponse);
        message.internalTransfers = ((_a = object.internalTransfers) !== null && _a !== void 0 ? _a : []).map((e) => exports.InternalTransfer.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryBlacklistRequest = { address: "" };
exports.QueryBlacklistRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryBlacklistRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryBlacklistRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryBlacklistRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryBlacklistResponse = { isBlacklisted: false };
exports.QueryBlacklistResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isBlacklisted === true) {
            writer.uint32(8).bool(message.isBlacklisted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryBlacklistResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isBlacklisted = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryBlacklistResponse);
        message.isBlacklisted =
            object.isBlacklisted !== undefined && object.isBlacklisted !== null
                ? Boolean(object.isBlacklisted)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.isBlacklisted !== undefined &&
            (obj.isBlacklisted = message.isBlacklisted);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryBlacklistResponse);
        message.isBlacklisted = (_a = object.isBlacklisted) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
const baseQueryBlacklistAllRequest = {};
exports.QueryBlacklistAllRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryBlacklistAllRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryBlacklistAllRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryBlacklistAllRequest);
        return message;
    },
};
const baseQueryBlacklistAllResponse = { address: "" };
exports.QueryBlacklistAllResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.address) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryBlacklistAllResponse);
        message.address = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryBlacklistAllResponse);
        message.address = ((_a = object.address) !== null && _a !== void 0 ? _a : []).map((e) => String(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.address) {
            obj.address = message.address.map((e) => e);
        }
        else {
            obj.address = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryBlacklistAllResponse);
        message.address = ((_a = object.address) !== null && _a !== void 0 ? _a : []).map((e) => e);
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.InternalTransfers = this.InternalTransfers.bind(this);
        this.Blacklist = this.Blacklist.bind(this);
        this.BlacklistAll = this.BlacklistAll.bind(this);
    }
    InternalTransfers(request) {
        const data = exports.QueryInternalTransfersRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bank.Query", "InternalTransfers", data);
        return promise.then((data) => exports.QueryInternalTransfersResponse.decode(new minimal_1.default.Reader(data)));
    }
    Blacklist(request) {
        const data = exports.QueryBlacklistRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bank.Query", "Blacklist", data);
        return promise.then((data) => exports.QueryBlacklistResponse.decode(new minimal_1.default.Reader(data)));
    }
    BlacklistAll(request) {
        const data = exports.QueryBlacklistAllRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bank.Query", "BlacklistAll", data);
        return promise.then((data) => exports.QueryBlacklistAllResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
